import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface KundeWerdenState extends BasePageState {}
interface KundeWerdenModel {}

export default class KundeWerdenPage extends Basepage<
  KundeWerdenState,
  KundeWerdenModel
> {
  renderChild(): JSX.Element {
    return <div id="kundeWerden">Kunde werden</div>;
  }
  initState(base: BasePageState): KundeWerdenState {
    let newState: KundeWerdenState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Kunde werden';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Kunde werden</span>;
  }
  getType(): string {
    return 'KundeWerdenPage';
  }
}
